// Floors instead of rounding so a rating like 4.7692 never displays as 4.8,
// which would incorrectly suggest a 4.8 threshold has been met.
export const formatRating = (rating: number): string => {
  const flooredRating = Math.floor(rating * 10) / 10;
  return flooredRating.toString().replace(/\.0$/, "");
};
